import { PATH_AGREEMENTS, PATH_ROOT } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useAgreementContext } from "../context";

export const useAgreementBreadcrumbs = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const context = useAgreementContext();

  const breadcrumbItems = useMemo((): BreadcrumbItem[] => {
    const isCreateMode = location.pathname.endsWith("/new");
    const items: BreadcrumbItem[] = [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      {
        label: t("navigation.agreements"),
        href: PATH_AGREEMENTS,
      },
    ];

    if (isCreateMode) {
      items.push({
        label: t("agreements.createForm.title"),
        href: undefined,
      });
    } else if (context.data?.agreement) {
      items.push({
        label: context.data.agreement.agreement_id,
        href: `${PATH_AGREEMENTS}/${context.data.agreement.agreement_id}`,
      });
    }
    return items;
  }, [location.pathname, t, context.data]);

  return {
    breadcrumbItems,
  };
};
